import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import get from 'lodash/get';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputGrupoCotizacion from 'components/blocks/ManagementNewForms/Inputs/FormInputGrupoCotizacion';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import useCreatetPagoUnicoCATA from 'services/record/PagoUnicoCATA/useCreatePagoUnicoCATA';
import useUpdatePagoUnicoCATAByID from 'services/record/PagoUnicoCATA/useUpdatePagoUnicoCATAByID';
import useBankAccounts from 'services/user/useBankAccounts';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


const PagoUnicoCATA = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createPagoUnicoCATA, loadingCreatePagoUnicoCATA, successCreatePagoUnicoCATA, errorCreatePagoUnicoCATA } = useCreatetPagoUnicoCATA();
    const { dataUpdatePagoUnicoCATAById, loadingUpdatePagoUnicoCATAById, successUpdatePagoUnicoCATAById, errorUpdatePagoUnicoCATAById, updatePagoUnicoCATAById } = useUpdatePagoUnicoCATAByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;

    // Hook para cuentas bancarias del usuario
    const { accounts: bankAccounts, getBankAccounts, getDefaultAccount } = useBankAccounts();
    const [bankAccountFromSettings, setBankAccountFromSettings] = useState(false);

    // Cargar cuentas bancarias al iniciar
    useEffect(() => {
        getBankAccounts();
    }, []);

    const adaptApiResponseToDefaultValues = (data: any) => {
        if (!data) return;
        console.log(data)

        // Determinar IBAN: del API o de la configuracion del usuario
        let ibanValue = data?.IBAN?.replace(/-/g, '') || "";
        let fromSettings = false;

        if (!ibanValue) {
            const defaultAccount = getDefaultAccount();
            if (defaultAccount) {
                ibanValue = defaultAccount.iban;
                fromSettings = true;
            }
        }
        setBankAccountFromSettings(fromSettings);

        reset({
            DatosPersonales: {

                SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
                SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
                SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
                SolicitanteIPF: data?.DatosPersonales?.IPF || "",
                SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",

                SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
                SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
                SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
                SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
                SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
                SolicitanteProvinciaDescripcion: data?.DatosPersonales?.provinciaDescripcion || "",
                SolicitanteComunidadCodigo: data?.DatosPersonales?.CodigoLocalidad || "",
                //DATOS OPCIONALES
                SolicitanteFechaNacimiento: data?.FechaNacimiento || "",
                SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
                SolicitanteEmail: data?.Email || "",
                //SolicitanteIRPF: data?.TipoIRPFVoluntario || null
            },

            TipoPago: {
                TipoPagoSolicitado: data?.TipoPagoUnico?.toString() || "",
                BaseCotizacion: data?.BaseCotizacionPrevista || "",
                CoberturaContingencias: data?.CoberturaContingencias?.toString() ?? null,
            },

            DesarrolloActividad: {
                DesarrolloActividadSolicitada: data?.TipoConstitucion?.toString() || "",
                SociedadLaboralCooperativa: data?.TipoSociedad?.toString() ?? null,
            },

            DatosBancarios: {
                SolicitanteIBAN: ibanValue,
            },
            Documentacion: adaptDocumentacion(data?.SeccionesDocumentacion || []),
        });
    };


    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const documentacionArray = await prepareDocumentacionArrayWithCase(data?.Documentacion || []);

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            // ACEPTACIÓN
            Acepto: data?.Acepto ?? false,

            // DATOS PERSONALES
            DatosPersonales: {
                Nombre: data?.DatosPersonales?.SolicitanteNombre || "",
                Apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
                Apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
                IPF: data?.DatosPersonales?.SolicitanteIPF || "",
                IPFTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,

                Telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
                Fijo: data?.DatosPersonales?.SolicitanteFijo || "",
                Domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
                CodigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
                provinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,
                NumeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || "",
                CodigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                LocalidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,

            },
            Email: data?.DatosPersonales?.SolicitanteEmail || "",

            FechaNacimiento: data?.DatosPersonales?.SolicitanteFechaNacimiento || "",
            // TIPO PAGO
            TipoPagoUnico: parseInt(data?.TipoPago?.TipoPagoSolicitado) || 0,
            BaseCotizacionPrevista: parseFloat(data?.TipoPago?.BaseCotizacion) || 0,
            CoberturaContingencias: parseInt(data?.TipoPago?.CoberturaContingencias) ?? null,

            // DESARROLLO ACTIVIDAD
            TipoConstitucion: parseInt(data?.DesarrolloActividad?.DesarrolloActividadSolicitada) || 0,
            TipoSociedad: parseInt(data?.DesarrolloActividad?.SociedadLaboralCooperativa) ?? 0,

            // DATOS BANCARIOS
            IBAN: data?.DatosBancarios?.SolicitanteIBAN
                ?.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-') || null,

            // DOCUMENTACIÓN
            Documentacion: documentacionArray
        }
        console.log(datosEnvio)
        if (info) {
            createPagoUnicoCATA(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            updatePagoUnicoCATAById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreatePagoUnicoCATA || loadingUpdatePagoUnicoCATAById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FormDatosPersonales emailVisible={true} activarSS={true} activarFechaNacimiento={true} />

                <AccordionForm title={'Tipo de pago único solicitado'} expandedInit={false} nombreError='TipoPago' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputRadioGroup
                                    title="Pago único solicitado"
                                    name="TipoPago.TipoPagoSolicitado"
                                    labels={["Abono en un único pago", "Subvención de las cuotas de cotización de la Seguridad Social", "Mixto"]}
                                    required="Debe seleccionar una opción"
                                    modal={["Abono en un único pago del valor actual del importe de la prestación contributiva (importe que le queda por cobrar).", null, "Mixta: Abono de parte del importe de la prestación contributiva pendiente y Subvención del importe de las cuotas de cotización de la Seguridad Social."]}
                                    col={12}
                                />

                                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                                    Se entiende que, si sólo solicita alguna de las dos primeras modalidades de abono, renuncia a una posterior solicitud de la
                                    otra modalidad
                                </p>
                                <AccordionDisplay
                                    fields={[
                                        'TipoPago.BaseCotizacion',
                                        'TipoPago.CoberturaContingencias'
                                    ]}
                                    dataUser={dataUser} visibility={watch('TipoPago.TipoPagoSolicitado') === '1' || watch('TipoPago.TipoPagoSolicitado') === '2'}>
                                    <FormInputText
                                        name='TipoPago.BaseCotizacion'
                                        id='TipoPago.BaseCotizacion'
                                        label='Base de cotización prevista'
                                        md={12}
                                        xl={12}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage="Introduce un número válido (entero o decimal, con '.' o ',')"
                                        disabled={false}
                                    />
                                    <FormInputRadioGroup
                                        title="Cobertura contingencias prevista"
                                        name="TipoPago.CoberturaContingencias"
                                        labels={["ITCC", "CP", "Cese de Actividad"]}
                                        required={(watch('TipoPago.codigoPagoSolicitado') === '1' || watch('TipoPago.codigoPagoSolicitado') === '2') ? "Debe seleccionar una opción en cobertura contingencias" : undefined}
                                        col={12}
                                    />
                                </AccordionDisplay>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Forma de constitución para el desarrollo de la actividad'} expandedInit={false} nombreError='DesarrolloActividad' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputRadioGroup
                                    title="Forma de constitución para el desarrollo de la actividad"
                                    name="DesarrolloActividad.DesarrolloActividadSolicitada"
                                    labels={["Trabajador/a autónomo/a", "Socio/a trabajador/a de sociedad labora", "Socio/a trabajador/a de sociedad cooperativa"]}
                                    required="Debe seleccionar una opción"
                                    col={12}
                                />

                                <AccordionDisplay fields={['DesarrolloActividad.SociedadLaboralCooperativa']} dataUser={dataUser} visibility={watch('DesarrolloActividad.DesarrolloActividadSolicitada') === '1' || watch('DesarrolloActividad.DesarrolloActividadSolicitada') === '2'}>

                                    <FormInputRadioGroup
                                        title="Caso de tratarse de sociedad laboral o cooperativa:"
                                        name="DesarrolloActividad.SociedadLaboralCooperativa"
                                        labels={["Incorporación a sociedad existente", "Sociedad de nueva creación"]}
                                        required={(watch('DesarrolloActividad.DesarrolloActividadSolicitada') === '1' || watch('DesarrolloActividad.DesarrolloActividadSolicitada') === '2') ? "Debe seleccionar una opción en cobertura contingencias" : undefined}
                                        col={12}
                                    />
                                </AccordionDisplay>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                {/* ////////////// DATOS BANCARIOS //////////// */}
                <AccordionForm title={'Datos Bancarios (Solicitante - Titular)'} expandedInit={false} nombreError='DatosBancarios' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            {bankAccountFromSettings && (
                                <div className="alert alert-info mb-3" style={{
                                    backgroundColor: '#D8F1FF',
                                    border: '1px solid #409CCE',
                                    borderRadius: '4px',
                                    padding: '12px 16px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#409CCE">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                                    </svg>
                                    <span style={{ color: '#4E4E4E', fontSize: '14px' }}>
                                        Datos bancarios cargados desde tu configuracion.
                                        <a href="/ajustes" style={{ color: '#409CCE', marginLeft: '4px' }}>
                                            Modificar en Ajustes
                                        </a>
                                    </span>
                                </div>
                            )}
                            <FieldsetContainer legend="Datos Bancarios" disabled={false}>

                                <FormInputCuentaBancaria
                                    id='DatosBancarios.SolicitanteIBAN'
                                    name='DatosBancarios.SolicitanteIBAN'
                                    xl={12}
                                    md={12}
                                    placeholder=''
                                    req='Falta el Número de Cuenta Bancaria' />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Documentacion'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormArrayArchivosReducidos
                                name={'Documentacion'}
                                urlArchivos={dataUser?.Documentacion?.map(d => d?.SasUri) || []}
                                setTotalSize={setTotalSize}
                            />

                        </div>
                    </div>
                </AccordionForm>












                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreatePagoUnicoCATA}
                    successUpdate={successUpdatePagoUnicoCATAById}
                    errorCreate={errorCreatePagoUnicoCATA}
                    errorUpdate={errorUpdatePagoUnicoCATAById}
                    datosAPI={datosAPI}
                    info={info}
                    MaxSizeMB={MAX_SIZE_MB}
                >
                    <div className="info-interes-content">

                        {/* REQUISITOS */}
                        <p className="fw-bold fs-5 mb-2">Requisitos</p>

                        <ol style={{ paddingLeft: "1.2rem" }}>
                            <li className="mb-2">
                                Haber solicitado y tener reconocido el derecho a la prestación por cese de actividad
                                de los/as trabajadores/as autónomos/as.
                            </li>

                            <li className="mb-2">
                                Tener pendiente el cobro de, al menos, <strong>seis meses</strong> de prestación.
                            </li>

                            <li className="mb-2">
                                Acreditar que se va a realizar una actividad profesional por cuenta propia,
                                o bien incorporarse a una cooperativa de trabajo o a una sociedad laboral.
                            </li>

                            <li className="mb-2">
                                Haber presentado la solicitud de pago único con fecha anterior a:
                                <ul style={{ listStyle: "none", paddingLeft: "1.5rem", marginTop: "0.3rem" }}>
                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        La constitución o incorporación a la cooperativa o sociedad laboral.
                                    </li>
                                    <li style={{ position: "relative" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        La fecha de inicio de la actividad (alta en la TGSS).
                                    </li>
                                </ul>
                            </li>

                            <li className="mb-2">
                                Una vez abonada la prestación en pago único, deberá darse de alta en la TGSS
                                e iniciar la actividad en el plazo máximo de <strong>un mes</strong>.
                            </li>
                        </ol>


                        {/* MEMORIA */}
                        <p className="fw-bold fs-5 mt-4 mb-2">
                            Contenido mínimo de la memoria explicativa del proyecto
                        </p>

                        <ol style={{ listStyle: "none", paddingLeft: 0 }}>

                            <li className="mb-3">
                                <strong>1.- Datos personales de todas las personas que integran el proyecto (socios/as, comuneros/as…)</strong>
                            </li>

                            <li className="mb-3">
                                <strong>2.- Datos del proyecto:</strong>

                                <ul style={{ listStyle: "none", paddingLeft: "1.5rem", marginTop: "0.3rem" }}>
                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Descripción de la actividad a desarrollar: servicios a prestar o bienes a producir, nueva actividad o actividad en funcionamiento.
                                    </li>

                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Domicilio, localidad y provincia donde se va a desarrollar la actividad (domicilio fiscal).
                                    </li>

                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Datos del local donde se va a realizar la actividad (caso de realizarse en domicilio distinto al propio):

                                        <ul style={{ listStyle: "none", paddingLeft: "1.8rem", marginTop: "0.2rem" }}>
                                            <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Indicar si tiene necesidad de él o no.
                                            </li>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Indicar si ya cuenta con el local o no. Y, en su caso, si es su propietario(a o lo va a adquirir o alquilar; y el coste de alquiler o compra. Dirección completa del local.
                                            </li>
                                        </ul>
                                    </li>

                                    <li style={{ position: "relative" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Marco jurídico dentro del que se va a desarrollar la actividad:

                                        <ul style={{ listStyle: "none", paddingLeft: "1.8rem", marginTop: "0.2rem" }}>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Sociedad Cooperativa.
                                            </li>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Sociedad Laboral (anónima o de responsabilidad limitada).
                                            </li>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Trabajador/a autónomo/a (informando de si se trata o no de profesional liberal de alta en Colegio Profesional).
                                            </li>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Comunidad de bienes o sociedad civil irregular.
                                            </li>
                                        </ul>
                                    </li>

                                </ul>
                            </li>

                            <li className="mb-3">
                                <strong>3.- Capital necesario total:</strong>

                                <ul style={{ listStyle: "none", paddingLeft: "1.5rem", marginTop: "0.3rem" }}>
                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Importe de las aportaciones a la cooperativa incluyendo la cuota de ingreso.
                                    </li>

                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Importe del desembolso necesario para la adquisición de acciones o participaciones de la sociedad laboral o mercantil.
                                    </li>

                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Importe de la inversión prevista para realizar una actividad como trabajador/a autónomo/a.
                                    </li>

                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Distribución prevista, de la inversión indicada:

                                        <ul style={{ listStyle: "none", paddingLeft: "1.8rem", marginTop: "0.2rem" }}>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Activos fijos (inmuebles, derechos de traspaso, maquinaria, elementos de transporte, equipos informáticos, otros…).
                                            </li>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Activo circulante (mercadería, materia prima, otros…).
                                            </li>
                                            <li style={{ position: "relative" }}>
                                                <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                                Gastos necesarios para el inicio de la actividad (cargas tributarias, gastos de colegiación, renting, servicio de asesoramiento, formación, información…).
                                            </li>
                                        </ul>
                                    </li>

                                    <li style={{ position: "relative" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Si tiene prevista o no la contratación de trabajadores/as.
                                    </li>

                                </ul>
                            </li>

                            <li className="mb-3">
                                <strong>4.- Forma de financiación:</strong>

                                <ul style={{ listStyle: "none", paddingLeft: "1.5rem", marginTop: "0.3rem" }}>
                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Capital propio (ahorros, etc.).
                                    </li>
                                    <li style={{ position: "relative", marginBottom: "0.2rem" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Capital ajeno (aportación de familiares, amigos/as, subvenciones, créditos bancarios, etc.). En el caso de créditos bancarios o de entidades financieras se hará constar: importe total del crédito, tipo de interés, periodo y coste de la amortización.
                                    </li>
                                    <li style={{ position: "relative" }}>
                                        <span style={{ position: "absolute", left: "-1rem" }}>-</span>
                                        Capitalización (importe que pretende obtener en concepto de pago único, según las necesidades de inversión, la aportación obligatoria o el tope legal establecido para los/as trabajadores/as autónomos/as, en su caso.
                                    </li>
                                </ul>
                            </li>

                        </ol>

                    </div>

                </FormBotonSubmit>


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div >
        </FormProvider >
    )
}

export default PagoUnicoCATA